import { Box, Typography } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

export const ContactPage: FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ mt: 10 }}>
      <Typography variant="h5" align="center">
        Contacteer ons:
      </Typography>
      <Box textAlign={"center"} mt={5}>
        <Typography variant="h6" align="center">
          E-mail:{" "}
          <a href="mailto: bart.ronsse@police.belgium.eu">
            bart.ronsse@police.belgium.eu
          </a>
        </Typography>
        <Typography variant="h6" align="center">
          Telefoon: 03 347 17 29
        </Typography>
        <Typography variant="h6" align="center">
          Website: <a href="https://politiezonerupel.be/">Politiezone Rupel</a>
        </Typography>
      </Box>
    </Box>
  );
};
